export const BIG_QUERY_OPTIONS = 'BIG_QUERY_OPTIONS';
export const BIG_QUERY_OPTIONS_DISABLE_DATASET_CREATION = 'BIG_QUERY_OPTIONS_DISABLE_DATASET_CREATION';
export const BIG_QUERY_OPTIONS_UNSPECIFIED = 'BIG_QUERY_OPTIONS_UNSPECIFIED';

export const TABLE_OVERRIDES = 'TABLE_OVERRIDES';
export const FIELD_OVERRIDES = 'FIELD_OVERRIDES';
export const PARTITIONING = 'PARTITIONING';
